var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTool = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 5.25C11.0974 5.40578 11.0119 5.61521 11.0119 5.83334C11.0119 6.05146 11.0974 6.2609 11.2501 6.41667L12.5835 7.75C12.7392 7.90269 12.9487 7.98822 13.1668 7.98822C13.3849 7.98822 13.5943 7.90269 13.7501 7.75L16.8918 4.60834C17.3108 5.53433 17.4377 6.56603 17.2555 7.56596C17.0733 8.56588 16.5907 9.48654 15.872 10.2052C15.1533 10.9239 14.2327 11.4065 13.2327 11.5887C12.2328 11.7709 11.2011 11.644 10.2751 11.225L4.51679 16.9833C4.18527 17.3149 3.73563 17.5011 3.26679 17.5011C2.79795 17.5011 2.34831 17.3149 2.01679 16.9833C1.68527 16.6518 1.49902 16.2022 1.49902 15.7333C1.49902 15.2645 1.68527 14.8149 2.01679 14.4833L7.77512 8.725C7.35609 7.79901 7.22922 6.76731 7.41141 5.76738C7.5936 4.76746 8.0762 3.8468 8.79489 3.1281C9.51359 2.40941 10.4342 1.92681 11.4342 1.74462C12.4341 1.56243 13.4658 1.68931 14.3918 2.10834L11.2585 5.24167L11.2501 5.25Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTool, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tool.9ee04b45.svg";
export { ForwardRef as ReactComponent };